
import ImageLoader from "@/assets/scripts/ImageLoader";
import HeaderLayout from "@/components/layouts/Header.vue";
import BannerLayout from "@/components/layouts/Banner.vue";
import FooterLayout from "@/components/layouts/Footer.vue";
import SingleBlock from "@/components/blocks/Single.vue";
import DoubleBlock from "@/components/blocks/Double.vue";
import NoticeAlert from "@/components/alerts/Notice.vue";
import PageButton from "@/components/buttons/Page.vue";
import SearchForm from "@/components/forms/Search.vue";

export default {
  name: "IndexView",
  components: {
    HeaderLayout,
    BannerLayout,
    FooterLayout,
    SingleBlock,
    DoubleBlock,
    NoticeAlert,
    PageButton,
    SearchForm,
  },
  data() {
    return {
      experienceImage: ImageLoader.loadImageSrc("assets/images/icons/experience.png"),
      goalImage: ImageLoader.loadImageSrc("assets/images/icons/goal.png"),
      codeImage: ImageLoader.loadImageSrc("assets/images/decorators/code.jpg"),
      computerImage: ImageLoader.loadImageSrc("assets/images/decorators/desktop_custom.jpg"),
    };
  },
};
